import { Button, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Warning } from 'assets/icons/warning-blue.svg';

interface SendVerifyLetterEmailModalProps {
	isOpen: boolean;
	onConfirm: () => void;
	onClose?: () => void;
}

export const SendVerifyLetterEmailModal: FC<SendVerifyLetterEmailModalProps> = ({
	isOpen,
	onConfirm,
	onClose,
}) => {
	const { t: modalsTranslate } = useTranslation(NamespacesList['modals']);

	const [{ minutes, seconds }, setTime] = useState({ minutes: 1, seconds: 30 });

	useEffect(() => {
		const interval = setInterval(() => {
			if (isOpen) {
				if (minutes === 0 && seconds === 0) {
					clearInterval(interval);
				} else {
					setTime((prevTime) => {
						if (prevTime.seconds > 0) {
							return { ...prevTime, seconds: prevTime.seconds - 1 };
						} else {
							return { minutes: prevTime.minutes - 1, seconds: 59 };
						}
					});
				}
			}
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	}, [minutes, seconds, isOpen]);

	return (
		<InfoModal
			isOpen={isOpen}
			onClose={() => {
				onClose?.();
				setTime({ minutes: 1, seconds: 30 });
			}}
			image={<Warning style={{ height: '60px', width: '60px' }} />}
			title={modalsTranslate('verifyEmail.title')}
			description={
				<>
					{modalsTranslate('verifyEmail.longerDescription')} <br />
					{(seconds > 0 || minutes > 0) && (
						<Typography
							sx={{
								marginTop: '12px',
								color: '#4786FF',
							}}
						>
							{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
						</Typography>
					)}
				</>
			}
			buttons={
				<Button
					sx={{
						height: '44px',
						width: { xs: '90%', sm: '438px' },
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '16px',
						fontWeight: '700',
						marginTop: '24px',
					}}
					type="submit"
					variant="contained"
					color="primary"
					disabled={minutes !== 0 || seconds !== 0}
					onClick={() => {
						onConfirm();
						setTime({ minutes: 1, seconds: 30 });
					}}
				>
					{modalsTranslate('errorVerifyEmail.confirm')}
				</Button>
			}
		></InfoModal>
	);
};
